import { IconProps } from "common/assets/icons/types";
import * as React from "react";

type Props = IconProps & { className?: string };

export const ArrowIcon: React.FC<React.PropsWithChildren<Props>> = ({
  color,
  className,
}) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h32v32H0z" />
        <path
          d="M16.485 9.228a.772.772 0 0 1 1.095 0l6.193 6.222a.78.78 0 0 1 0 1.1l-6.193 6.222a.772.772 0 0 1-1.095 0 .78.78 0 0 1 0-1.1l4.872-4.894H8.774A.776.776 0 0 1 8 16c0-.43.347-.778.774-.778h12.583l-4.872-4.894a.78.78 0 0 1 0-1.1Z"
          fill={color}
        />
      </g>
    </svg>
  );
};
